import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ColoredButton from "../../../shared/components/ColoredButton";

const styles = (theme) => ({
  termsConditionsListitem: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
  },
  dialogActions: {
    justifyContent: "flex-start",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  backIcon: {
    marginRight: theme.spacing(1),
  },
});

function TermsOfServiceDialog(props) {
  const { classes, onClose, theme } = props;
  return (
    <Dialog open scroll="paper" onClose={onClose} hideBackdrop>
      <DialogTitle>Aviso de Privacidad</DialogTitle>
      <DialogContent>
        <Typography variant="h6" color="primary" paragraph>
          Aviso de Privacidad
        </Typography>

        {/* Párrafo introductorio */}
        <Typography paragraph>
          En cumplimiento a la LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN
          POSESIÓN DE LOS PARTICULARES (la Ley); los datos personales
          solicitados, son tratados por IMAR SISTEMAS con domicilio en VIVEROS
          DE LA PARROQUIA #10, COL. VIVEROS DE LA LOMA, TLALNEPANTLA DE BAZ, CP
          54080, ESTADO DE MÉXICO, MÉXICO.
        </Typography>

        <Typography paragraph>
          El nombre completo de IMAR SISTEMAS es el siguiente:
        </Typography>
        <Typography paragraph component="div">
          • Imar Sistemas, S.A. DE C.V.
        </Typography>

        <Typography paragraph>
          En todo momento usted podrá revocar el consentimiento que nos ha
          otorgado para el tratamiento de sus datos personales, a fin de que
          dejemos de hacer uso de estos.
        </Typography>

        <Typography paragraph>
          ¿Cómo contactarnos? Oficina de privacidad: IMAR SISTEMAS, S.A. DE C.V.
          <br />
          Domicilio: VIVEROS DE LA PARROQUIA #10, COL. VIVEROS DE LA LOMA,
          TLALNEPANTLA DE BAZ, CP 54080, ESTADO DE MÉXICO, MÉXICO.
          <br />
          Correo electrónico: <strong>privacidad@imarsistemas.com</strong>.
          <br />
          Teléfono: 01 (55) 2628 3590
        </Typography>

        {/* Recopilación de la información */}
        <Typography variant="h6" color="primary" paragraph>
          Recopilación de la información
        </Typography>
        <Typography paragraph>
          Como visitante, usted no tiene que proporcionar información personal
          para utilizar el sitio web. Este sitio web solo recopila, en el
          formulario que se muestra en la anterior liga, datos personales de
          contacto que son proporcionados de forma voluntaria por los visitantes
          en caso de que quiera contactarnos.
        </Typography>
        <Typography paragraph>
          Dicha información consiste en su nombre, cargo actual, la dirección de
          la empresa, dirección de correo electrónico corporativo y números de
          teléfono y fax.
        </Typography>
        <Typography paragraph>
          Nosotros no solicitamos información sensible (por ejemplo, los datos
          relacionados con la raza o el origen étnico, las creencias religiosas,
          antecedentes penales, salud física, mental, o la orientación sexual)
          de los visitantes. En caso necesario, obtendremos su consentimiento
          expreso y por escrito para recabar y utilizar dicha información.
        </Typography>

        {/* Datos personales que recabamos */}
        <Typography variant="h6" color="primary" paragraph>
          Datos personales que recabamos
        </Typography>
        <Typography paragraph>
          Recabamos sus datos personales que no son considerados como datos
          personales sensibles. Los datos son recabados ya sea en forma directa,
          cuando visita nuestro sitio de internet, adquiere o utiliza nuestros
          servicios o productos, así como cuando participa en nuestros eventos.
          Los datos que obtenemos por este medio pueden ser, entre otros:
        </Typography>
        <Typography paragraph component="div">
          • NOMBRE COMPLETO
          <br />
          • EMPRESA
          <br />
          • ESTADO
          <br />
          • PUESTO ACTUAL
          <br />
          • TELÉFONOS
          <br />• CORREO ELECTRÓNICO
        </Typography>
        <Typography paragraph>
          En caso de no contar con esta información, no estaríamos en
          posibilidad de brindarle oportunamente el servicio o producto que nos
          contrate o pueda llegar a contratar.
        </Typography>
        <Typography paragraph>
          Para el tratamiento de datos personales con fines comerciales, estos
          se denominan “Datos parciales” y se componen de los siguientes:
        </Typography>
        <Typography paragraph component="div">
          • NOMBRE COMPLETO
          <br />
          • CORREO ELECTRÓNICO
          <br />• EMPRESA
        </Typography>
        <Typography paragraph>
          Para las finalidades señaladas en el presente AVISO DE PRIVACIDAD,
          podemos recabar sus datos personales de distintas formas, como por
          ejemplo cuando usted nos los proporciona directamente; cuando visita
          nuestro sitio de Internet o utiliza nuestros servicios y productos en
          línea, y cuando obtenemos información a través de otras fuentes que
          están permitidas.
        </Typography>

        {/* Finalidades para el tratamiento de sus datos personales */}
        <Typography variant="h6" color="primary" paragraph>
          Finalidades para el tratamiento de sus datos personales
        </Typography>
        <Typography paragraph>
          Su información personal será utilizada para las siguientes finalidades
          principales, las cuales son necesarias para proporcionarles nuestros
          productos y servicios:
        </Typography>
        <Typography paragraph component="div">
          • Identificarlo y contactarlo.
          <br />
          • Integrar su expediente como cliente o prospecto de cliente, y darlo
          de alta en nuestros sistemas.
          <br />
          • Verificar que no existen conflictos de independencia con nuestros
          empleados o sociedades.
          <br />
          • Proveerle los productos y servicios que contrata con nosotros, y
          cumplir las obligaciones contraídas con usted.
          <br />
          • Cumplir con la normatividad aplicable.
          <br />
          • Realizar el proceso relacionado con la facturación.
          <br />• En su caso, efectuar gestiones de cobranza.
        </Typography>

        <Typography paragraph>
          Adicionalmente, su información personal será utilizada con las
          siguientes finalidades secundarias:
        </Typography>
        <Typography paragraph component="div">
          • Evaluar la calidad de nuestro servicio.
          <br />
          • Invitarlo a eventos profesionales, académicos y culturales.
          <br />• Promocionarle nuestros productos y servicios, contactándolo y
          realizando eventos con propósitos mercadotécnicos, publicitarios o de
          prospección comercial.
        </Typography>
        <Typography paragraph>
          Si usted no desea que sus datos personales sean tratados para las
          finalidades secundarias señaladas, o alguna de ellas, puede negarnos
          su consentimiento desde este momento, enviándonos su solicitud a
          través de la Herramienta. Su negativa en este sentido no será motivo
          para que le dejemos de proporcionar los productos o servicios que
          contrate con nosotros, y le informamos que usted cuenta con un plazo
          de cinco días hábiles para hacérnosla saber.
        </Typography>

        {/* Uso de cookies y web beacons */}
        <Typography variant="h6" color="primary" paragraph>
          Uso de cookies y web beacons
        </Typography>
        <Typography paragraph>
          Este sitio recaba información estándar de registro, incluyendo su
          dirección IP, tipo de navegador, el idioma, tiempos de acceso y
          direcciones de sitios web. Para asegurar que este sitio web está
          siendo bien administrado y facilitar una mejor navegación, nosotros o
          nuestros proveedores de servicios podemos utilizar cookies (pequeños
          archivos de texto que se almacenan en el navegador del usuario) o web
          beacons (imágenes electrónicas que permiten contar los visitantes que
          han accedido a una página en particular y acceder a determinadas
          cookies) para recabar datos agregados.
        </Typography>
        <Typography paragraph>
          Las cookies que utilizamos para obtener su información personal se
          pueden deshabilitar accediendo al siguiente vínculo Internet Explorer
          Mozilla Firefox Safari Opera Google Chrome.
        </Typography>
        <Typography paragraph>
          Le informamos que utilizamos cookies para obtener información personal
          de usted, como la siguiente: Nombre y empresa, correo electrónico,
          apartados visitados en nuestras páginas.
        </Typography>

        {/* Limitar el uso de sus datos personales */}
        <Typography variant="h6" color="primary" paragraph>
          Limitar el uso de sus datos personales
        </Typography>
        <Typography paragraph>
          Usted puede dejar de recibir llamadas telefónicas de nuestro personal,
          así como recibir correo electrónico publicitario o de información
          técnica enviando correo electrónico a la dirección:{" "}
          <strong>privacidad@imarsistemas.com</strong>, indicando, a fin de
          poder atender en forma inmediata su solicitud, los siguientes datos:
        </Typography>
        <Typography paragraph component="div">
          • En el asunto: REMOVER
          <br />• En el cuerpo del correo: nombre completo, teléfono y correo
          electrónico.
        </Typography>

        {/* ¿Cómo acceder a rectificar o limitar sus datos...? */}
        <Typography variant="h6" color="primary" paragraph>
          ¿Cómo acceder a rectificar o limitar sus datos personales o cancelar u
          oponerse a su uso?
        </Typography>
        <Typography paragraph>
          Usted tiene el derecho de acceder a sus datos personales que poseemos
          y a los detalles del tratamiento de estos, así como a rectificarlos en
          caso de ser inexactos o instruirnos, cancelarlos cuando considere que
          resulten ser excesivos o innecesarios para las finalidades que
          justificaron su obtención u oponerse al tratamiento de estos para
          fines específicos.
        </Typography>

        {/* Divulgación de información a terceros */}
        <Typography variant="h6" color="primary" paragraph>
          Divulgación de información a terceros
        </Typography>
        <Typography paragraph>
          Podremos proporcionar su información personal denominada “Datos
          parciales” a otras entidades relacionadas con IMAR SISTEMAS, como
          Servicios Especializados en Comercio Exterior TRC, TRC Advisor,
          Control de Activos, Modelo especializado en tecnología aduanera y
          Corporativo aduanal especializado a fin de proporcionarle la
          información que podría ser de interés para usted y realizar otras
          investigaciones de mercado. Los datos personales de contacto también
          podrán ser revelados a terceras partes, a fin de responder a sus
          solicitudes de servicios o preguntas, cuando estas no se encuentren
          dentro de la especialidad de IMAR SISTEMAS.
        </Typography>
        <Typography paragraph>
          La información personal también puede ser revelada a las autoridades,
          agencias gubernamentales reguladoras o de otro tipo, o a terceros, en
          caso de que sea necesario para cumplir con obligaciones o
          requerimientos de la autoridad competente.
        </Typography>
        <Typography paragraph>
          Al proporcionar información a través de este sitio web, usted acepta
          la transferencia o remisión de datos personales para las finalidades
          descritas en los Avisos de Privacidad y las descritas en este
          apartado. Si usted no manifiesta su oposición para que sus datos
          personales sean transferidos, se entenderá que ha otorgado su
          consentimiento para ello.
        </Typography>

        {/* Modificaciones al aviso de privacidad */}
        <Typography variant="h6" color="primary" paragraph>
          Modificaciones al aviso de privacidad
        </Typography>
        <Typography paragraph>
          IMAR SISTEMAS se reserva el derecho de efectuar en cualquier momento
          modificaciones o actualizaciones al presente aviso de privacidad, para
          la atención de novedades legislativas o jurisprudenciales, políticas
          internas, nuevos requerimientos para la prestación u ofrecimiento de
          nuestros servicios o productos y prácticas del mercado.
        </Typography>
        <Typography paragraph>
          Estas modificaciones estarán disponibles al público en nuestra página
          de Internet <strong>www.imarsistemas.com</strong>, sección aviso de
          privacidad.
        </Typography>

        {/* Última actualización */}
        <Typography paragraph>
          Última actualización al presente aviso de privacidad: 05/03/2025
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <ColoredButton
          onClick={onClose}
          variant="contained"
          color={theme.palette.common.black}
        >
          <ArrowBackIcon className={classes.backIcon} />
          Regresar
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
}

TermsOfServiceDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TermsOfServiceDialog);
